/**
 * Budget Module Configuration
 * Centralized configuration for budget-related settings
 */

/**
 * Currency Configuration
 * Single source of truth for currency settings with defaults
 */
export const BUDGET_CONFIG = {
  // Currency code (ISO 4217)
  CURRENCY: import.meta.env.VITE_BUDGET_CURRENCY || 'JPY',
  
  // Currency symbol for display
  CURRENCY_SYMBOL: import.meta.env.VITE_BUDGET_CURRENCY_SYMBOL || '￥',
  
  // Locale for number formatting
  LOCALE: import.meta.env.VITE_BUDGET_LOCALE || 'ja-JP',
  
  // Get formatted currency label (e.g., "¥/hr")
  getCurrencyPerHour: () => `${BUDGET_CONFIG.CURRENCY}/hr`,
  
  // Get currency with parentheses (e.g., "(JPY)")
  getCurrencyLabel: () => `(${BUDGET_CONFIG.CURRENCY})`,
} as const;

// Re-export for convenience
export const CURRENCY = BUDGET_CONFIG.CURRENCY;
export const CURRENCY_SYMBOL = BUDGET_CONFIG.CURRENCY_SYMBOL;
export const LOCALE = BUDGET_CONFIG.LOCALE;